var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationIocn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 6.76215C1.05585 5.21508 1.70969 3.74999 2.82392 2.67526C3.93815 1.60053 5.42587 1 6.97395 1C8.52203 1 10.0097 1.60053 11.124 2.67526C12.2382 3.74999 12.892 5.21508 12.9479 6.76215V6.85555C12.7761 9.01703 11.8146 11.0396 10.247 12.5376C9.40635 13.4186 8.46897 14.2019 7.45264 14.8727C7.32022 14.9856 7.15188 15.0477 6.97784 15.0477C6.80379 15.0477 6.63545 14.9856 6.50303 14.8727C4.98655 13.8861 3.65592 12.6398 2.57229 11.191C1.60883 9.92557 1.0646 8.3908 1.01556 6.80106L1 6.76215Z",
    stroke: "#757C8D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.97784 8.79348C8.03534 8.79348 8.89262 7.93621 8.89262 6.87871C8.89262 5.8212 8.03534 4.96393 6.97784 4.96393C5.92034 4.96393 5.06306 5.8212 5.06306 6.87871C5.06306 7.93621 5.92034 8.79348 6.97784 8.79348Z",
    stroke: "#757C8D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIocn);
export default __webpack_public_path__ + "static/media/locationIocn.ef548395e2843be41bf460fec1085292.svg";
export { ForwardRef as ReactComponent };